export function dispatchAgentAssistEvent(eventName, arg) {
    window.dispatchAgentAssistEvent(eventName, arg);
}
